import React from 'react';
import theme from 'src/theme';

type T = Record<string, React.CSSProperties>;

const S: T = {
    dailogPaperPropsSX: {
        minWidth: 500,
        minHeight: 445,
        backgroundColor: theme.color.darkBlue
    },
    modalTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        fontFamily: '"Inter",sans-serif',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '19px',
        marginTop: '25px',
        color: theme.color.white90
    },
    modalContent: {
        marginTop: '15px'
    },
    closeButton: {
        position: 'absolute',
        right: 8,
        color: theme.color.white70
    }
};

export default S;
